import { create } from 'zustand';

type Store = {
    notify: any[];
    setNotify: (value: any) => void;
    clearNotify: () => void
};

export const useNotifyStore = create<Store>((set) => ({
    notify: [],
    setNotify: (value: any) => set({ notify: value }),
    clearNotify: () => set({ notify: [] }),

}));


